import { ref } from 'vue'
import { useMediaStore } from '@/pinia/MediaStore'

export default function () {
  const files = ref([])
  const mediaStore = useMediaStore()

  const addFile = async (file) => {
    return new Promise(resolve => {
      const reader = new FileReader()
      reader.readAsArrayBuffer(file)
      reader.onload = (evt) => {
        return resolve(evt.target.result)
      }
    })
  }

  const fnUploadFile = async (file, type, params) => {
    console.log('file', file)
    const formData = new FormData()
    formData.append('file', file.value[0].file)
    file.status = 'loading'

    if (type === 'media') {
      console.log('upload')
      await mediaStore.upload(formData, params)
    }
  }

  async function addFiles (newFiles) {
    const newUploadableFiles = [...newFiles].map((file) => new UploadableFile(file)).filter((file) => !fileExists(file.id))
    files.value = files.value.concat(newUploadableFiles)
  }

  function fileExists (otherId) {
    return files.value.some(({ id }) => id === otherId)
  }

  function removeFile (file) {
    const index = files.value.indexOf(file)

    if (index > -1) files.value.splice(index, 1)
  }

  return { files, addFiles, removeFile }
}

class UploadableFile {
  constructor (file) {
    const mediaStore = useMediaStore()
    this.file = file
    this.id = `${file.name}-${file.size}-${file.lastModified}-${file.type}`
    this.status = null
    this.isLoading = false
    mediaStore.addNewFile({
      file,
      id: `${file.name}-${file.size}-${file.lastModified}-${file.type}`,
      status: null,
      isLoading: false
    })
  }
}
